import Target from './target';

import { TargetSessionStatuses } from '../../../../../redux/API/ClientAPIHelpers/sessionsProperties';
import { useSelector } from '../../../../../redux/store';

const ActiveTargets = ({ fetchData }: { fetchData: () => void }) => {
	const targets = useSelector((state) => state.session.targets);

	return (
		<>
			{targets
				.filter((x) => x.targetStatus !== TargetSessionStatuses.new)
				.sort((a, b) => {
					if (a.orderId < b.orderId) return 1;

					return -1;
				})
				.map((item) => (
					<Target item={item} fetchData={fetchData} key={item.id} />
				))}
		</>
	);
};

export default ActiveTargets;
